export function UrlData() {
    return {
        name: "url",
        label: "URL",
        primitiveType: "string",
    };
}

export default UrlData;
